import moment from "moment";
import { ClassAttributes, HTMLAttributes, useEffect, useState, useContext } from "react";
import "react-datepicker/dist/react-datepicker.css";
import "react-loading-skeleton/dist/skeleton.css";
import { useMutation, useQuery } from "react-query";
import { Link } from "react-router-dom";
import UpdateProductModal from "../../components/ModalUpdateProduct";
import UpdateSecondmentModal from "../../components/ModalUpdateSecondment";
import UpdateServiceModal from "../../components/ModalUpdateService";
import PageInfiniteScroll from "../../components/PageInfiniteScroll";
import StickyContainer from "../../components/StickyContainer";
import { httpDELETE, httpGET } from "../../utils/ajaxHelper";
import { handleNumericDateInput } from "../../utils/helper";
import { CustomScroll } from "../inquiryManagement/inquiryManagement.styled";
import DeleteConfirmModal from "./deleteConfirmModal";
import DeleteSuccessModal from "./deleteSuccess";
import { ArrowDownIcon } from "../../assets/svg/arrowDown";
import { ArrowUpIcon } from "../../assets/svg/arrowUp";
import { ArrowDownGrayIcon } from "../../assets/svg/arrowDownGrayIcon";
import { PageContainerContext} from "../../Provider";
import { SORT_FIELDS_OFFERING_ADMIN } from "../../utils/constant";
import {
	AGButton,
	AGButtonPrimary,
	AGButtonPrimarySearch,
	AGSearch,
	AGSelect,
	ButtonContainer,
	Container,
	FirmName,
	FirmNameValue,
	InputContainer,
	InputLabel,
	InputSearch,
	LastUpdate,
	LastUpdateValue,
	Result,
	SearchContainer,
	StyledDatePicker,
	Tab,
	Title,
	TitleRow,
	Value
} from "./style";

const DropdownIndicatorLocation = (props: {
	innerProps: JSX.IntrinsicAttributes &
	ClassAttributes<HTMLDivElement> &
	HTMLAttributes<HTMLDivElement>;
}) => {
	return (
		<div {...props.innerProps}>
			<LocationIcon />
		</div>
	);
};

const DropdownIndicatorOfferingType = (props: {
	innerProps: JSX.IntrinsicAttributes &
	ClassAttributes<HTMLDivElement> &
	HTMLAttributes<HTMLDivElement>;
}) => {
	return (
		<div {...props.innerProps}>
			<OfferingTypeIcon />
		</div>
	);
};

const customSelectStyles = {
	dropdownIndicator: () => ({
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		width: "40px",
		height: "100%",
	}),
};

const LocationIcon = () => {
	return (
		<svg
			version="1.1"
			id="_x32_"
			xmlns="http://www.w3.org/2000/svg"
			xmlnsXlink="http://www.w3.org/1999/xlink"
			viewBox="0 0 512 512"
			xmlSpace="preserve"
			fill="rgb(39, 129, 186)"
			width="17"
			height="17"
			style={{
				marginRight: 10,
			}}>
			<g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
			<g
				id="SVGRepo_tracerCarrier"
				strokeLinecap="round"
				strokeLinejoin="round"></g>
			<g id="SVGRepo_iconCarrier">
				{" "}
				<g>
					{" "}
					<path
						className="st0"
						d="M256,0C159.969,0,82.125,77.859,82.125,173.906C82.125,269.938,236.797,512,256,512 c19.219,0,173.875-242.063,173.875-338.094C429.875,77.859,352.031,0,256,0z M256,240.406c-36.719,0-66.5-29.781-66.5-66.5 c0-36.75,29.781-66.531,66.5-66.531s66.516,29.781,66.516,66.531C322.516,210.625,292.719,240.406,256,240.406z"></path>{" "}
				</g>{" "}
			</g>
		</svg>
	);
};

const OfferingTypeIcon = () => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="30" height="8" viewBox="0 0 13 8" fill="none">
			<path d="M0.914688 1.40367L0.914672 1.40369L0.917491 1.40644L6.26749 6.63144L6.5015 6.85998L6.73442 6.63033L12.0844 1.35533L12.0844 1.35533L12.0861 1.35367C12.1809 1.25885 12.3199 1.25885 12.4147 1.35367C12.5092 1.44822 12.5095 1.58662 12.4155 1.68143C12.4152 1.68171 12.415 1.68199 12.4147 1.68227L6.66676 7.33021L6.66676 7.3302L6.66469 7.33227C6.56838 7.42857 6.52352 7.43463 6.50039 7.43463C6.44147 7.43463 6.39042 7.4202 6.32064 7.36707L0.585263 1.73143C0.491268 1.63663 0.491545 1.49822 0.586093 1.40367C0.680918 1.30885 0.819863 1.30885 0.914688 1.40367Z" fill="#637381" stroke="#637381" strokeWidth="0.666667" />
		</svg>
	);
};

const SearchIcon = () => {
	return (
		<svg
			fill="rgb(39, 129, 186)"
			width="151px"
			height="151px"
			viewBox="0 0 1920 1920"
			xmlns="http://www.w3.org/2000/svg"
			stroke="rgb(39, 129, 186)"
			style={{ marginRight: 10 }}>
			<g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
			<g
				id="SVGRepo_tracerCarrier"
				strokeLinecap="round"
				strokeLinejoin="round"></g>
			<g id="SVGRepo_iconCarrier">
				{" "}
				<path
					d="M790.588 1468.235c-373.722 0-677.647-303.924-677.647-677.647 0-373.722 303.925-677.647 677.647-677.647 373.723 0 677.647 303.925 677.647 677.647 0 373.723-303.924 677.647-677.647 677.647Zm596.781-160.715c120.396-138.692 193.807-319.285 193.807-516.932C1581.176 354.748 1226.428 0 790.588 0S0 354.748 0 790.588s354.748 790.588 790.588 790.588c197.647 0 378.24-73.411 516.932-193.807l516.028 516.142 79.963-79.963-516.142-516.028Z"
					fillRule="evenodd"></path>{" "}
			</g>
		</svg>
	);
};

const ExpertiseServiceManagement = () => {
	const pageContainerDivRef = useContext(PageContainerContext)
	const [serviceId, setServiceId] = useState<number | undefined>(undefined)
	const [productId, setProductId] = useState<number | undefined>(undefined)
	const [secondmentId, setSecondmentId] = useState<number | undefined>(undefined)
	const [selectedFirm, setSelectedFirm] = useState<number | undefined>(undefined)
	const [selectedOfferingType, setSelectedOfferingType] = useState("")
	const [servicesPagination, setServicesPagination] = useState<any>(undefined)
	const [services, setServices] = useState<any[]>([])
	const [isFirstSorting, setIsFirstSorting] = useState(false)
	const [searchParams, setSearchParams] = useState<any>({
		firmName: "",
		locations: [],
		offeringTypes: [],
		lastUpdate: undefined,
		pageNumber: 1,
		sort: 1,
		sortField: SORT_FIELDS_OFFERING_ADMIN.OFFERING_TYPE_ID
	});
	const [selectedService, setSelectedService] = useState("");
	const [sortParam, setSortParam] = useState({
		field: SORT_FIELDS_OFFERING_ADMIN.OFFERING_TYPE_ID,
		order: 1
	});

	const { mutate: getServices } = useMutation(
		() =>
			httpGET({
				url: "/ExpertiseService/search-admin",
				params: { 
					serviceName: searchParams.firmName,
					locations: searchParams.locations.map((item: any) => item?.value).join(","),
					offeringTypes: searchParams.offeringTypes.map((item: any) => item?.value).join(","),
					lastUpdate: searchParams.lastUpdate
						? moment(searchParams.lastUpdate).format("M/D/YYYY")
						: null,
					sort: searchParams.sort,
					sortField: searchParams.sortField,
					pageNumber: searchParams.pageNumber
				},
			}),
		{
			onSuccess: (rs) => {
				setServicesPagination(rs);
				if (isFirstSorting){
					if (searchParams.pageNumber < 2){
						setIsFirstSorting(false);
						setServices(rs.data);
					}else{
						setServices((prev) => [...prev, ...rs.data]);
					}
				}
				else if (searchParams.pageNumber < 2){
					setServices(rs.data);
				} else {
					setServices((prev) => [...prev, ...rs.data]);
				}
			},
		},
	);

	const getLocation = async () => {
		const data = await httpGET({
			url: "/agnetregion",
		});
		return data;
	};

	const getOfferingType = async () => {
		const data = await httpGET({
			url: "/ComMainService/offering-type",
		});
		return data;
	};

	const { data: location } = useQuery(["getLocation"], getLocation);
	const { data: offeringType } = useQuery(["getOfferingType"], getOfferingType);
	const [deleteSuccess, setDeleteSuccess] = useState(false);

	const toggleDeleteSuccess = () => setDeleteSuccess(!deleteSuccess);
	const [openConfirm, setOpenConfirm] = useState(false);
	const toggleOpenConfirm = () => setOpenConfirm(!openConfirm);

	const { mutate: deleteService } = useMutation(
		(serviceID: string) =>
			httpDELETE({
				url: "/ExpertiseService/delete",
				params: {
					comFirmDataId: serviceID,
					serviceName: searchParams.firmName,
					locations: searchParams.locations.map((item: any) => item?.value).join(","),
					offeringTypes: searchParams.offeringTypes.map((item: any) => item?.value).join(","),
					lastUpdate: searchParams.lastUpdate
						? moment(searchParams.lastUpdate).format("M/D/YYYY")
						: null,
					sort: searchParams.sort,
					sortField: searchParams.sortField,
					pageNumber: searchParams.pageNumber
				},
			}),
		{
			onSuccess: (rs) => {
				setServices(services.filter(x=>x.firmData.comOfferingId !== rs.deletedId));
				if (rs.appendedItem !== null){
					setServices(prevServices => [...prevServices, rs.appendedItem]);
				}
				setServicesPagination({...servicesPagination, maxLength: servicesPagination.maxLength-1});

				toggleDeleteSuccess();
				setServiceId(undefined);
				setProductId(undefined);
				setSecondmentId(undefined);
			},
		},
	);

	const filterServices = (
		searchParams.lastUpdate
			? services?.filter((item: any) => {
				return (
					moment(item?.lastUpdate).format("MM/DD/YYYY") ===
					moment(searchParams?.lastUpdate).format("MM/DD/YYYY")
				);
			})
			: services
	)?.map((item: any) => {
		return {
			...item,
			serviceName: item?.mainService?.mainServiceName,
			createdDate: item?.firmData?.dateEntered,
		};
	});

	const getOfferingTypeName = (id: number) => {
		switch (id) {
			case 1:
				return "service";
			case 2:
				return "product";
			case 3:
				return "secondment";
			default:
				return "service";
		}
	};

	const resetOfferingState = () => {
		setServiceId(undefined);
		setProductId(undefined);
		setSecondmentId(undefined)
	};

	const handleEditSuccessfully = (rs: any) => {
		setServices(prev => {
			const updated = prev.map(service =>
				service.firmData?.comOfferingId === rs.comOfferingId
				  ? {
					  ...service,
					  lastUpdate: rs.lastUpdate,
					  firmData: {
						...service.firmData,
						lastUpdate: rs.lastUpdate
					  }
					}
				  : service
			  );
		
			if (sortParam.field === "lastUpdate" && sortParam.order === 0) {
			  return [...updated].sort(
				(a, b) => new Date(a.lastUpdate).getTime() - new Date(b.lastUpdate).getTime()
			  );
			}
		
			if (sortParam.field === "lastUpdate" && sortParam.order === 1) {
			  return [...updated].sort(
				(a, b) => new Date(b.lastUpdate).getTime() - new Date(a.lastUpdate).getTime()
			  );
			}
		
			return updated;
		  });
	};

	const movePageToTop = ()=>{
        pageContainerDivRef?.current?.scrollTo({ top: 0, behavior: "auto" });
    }

	useEffect(() => {
			getServices();
			// eslint-disable-next-line react-hooks/exhaustive-deps
		}, [searchParams])

	return (
		<Container>
			{serviceId && (
				<UpdateServiceModal
					visible={!serviceId === false}
					toggleModal={() => {
						resetOfferingState();
					}}
					id={`${serviceId}`}
					publishComplete={() => {
						resetOfferingState();
					}}
					onDeleteService={() => {
						setOpenConfirm(!openConfirm)
					}}
					toggleError={() => {
						resetOfferingState();
					}}
					onEditSuccess={(rs)=>{
						handleEditSuccessfully(rs);
					}}
				/>
			)}

			{productId && (
				<UpdateProductModal
					visible={!productId === false}
					toggleModal={() => {
						resetOfferingState();
					}}
					id={`${productId}`}
					publishComplete={() => {
						resetOfferingState();
					}}
					onDeleteService={() => {
						setOpenConfirm(!openConfirm)
					}}
					toggleError={() => {
						resetOfferingState();
					}}
					onEditSuccess={(rs: any)=>{
						handleEditSuccessfully(rs);
					}}
				/>
			)}

			{secondmentId && (
				<UpdateSecondmentModal
					publishComplete={() => {
						resetOfferingState();
					}}
					visible={!secondmentId === false}
					toggleModal={() => {
						resetOfferingState();
					}}
					toggleError={() => {
						resetOfferingState();
					}}
					offeringId={`${secondmentId}`}
					onDeleteService={(e) => {
						setOpenConfirm(!openConfirm)
					}}
					organizationId={Number(selectedFirm)}
					onEditSuccess={(rs: any)=>{
						handleEditSuccessfully(rs);
					}}
			  />
			)}

			<DeleteSuccessModal
				visible={deleteSuccess}
				toggleModal={toggleDeleteSuccess}
				offeringType={`${selectedOfferingType}`}
			/>
			<DeleteConfirmModal
				visible={openConfirm}
				toggleModal={toggleOpenConfirm}
				selectedService={selectedService}
				deleteService={(id)=>{
					deleteService(id)
				}}
				offeringType={`${selectedOfferingType}`}
			/>
			<StickyContainer top={70}>

				<div className="flex mb-6 border-gray-200 border w-fit	rounded p-3 bg-white">
					{/* <Tab>
					<Link to="/">Marketplace</Link>
				</Tab> */}
					<Tab>
						<Link to="/dashboard-admin">
							Admin Dashboard
						</Link>
					</Tab>
					<Tab >
						<Link to="/inquiry-management">
							Inquiries Management
						</Link>
					</Tab>
					<Tab>
						<Link to="/admin-firm-management">
							Organizations Management
						</Link>
					</Tab>
					<Tab className="active">Offerings Management</Tab>
				</div>

			<SearchContainer>
				<TitleRow>
					<Title> Offerings Management</Title>
				</TitleRow>
				<InputContainer>
					<InputLabel>Search Offering Name</InputLabel>
					<InputSearch>
						<AGSearch
							placeholder="Search a name or keywords"
							value={searchParams.firmName}
							onChange={(e) =>{
								movePageToTop();
								setSearchParams({
									...searchParams,
									firmName: e.target?.value,
									pageNumber: 1,
								})
							}
							}
						/>
						<SearchIcon />
					</InputSearch>
				</InputContainer>

				<InputContainer>
					<InputLabel>Region</InputLabel>
					<AGSelect
						className="custom-select"
						options={location?.map((item: any) => ({
							value: item?.netRegionId,
							label: item?.netRegionName,
						}))}
						placeholder="Select region"
						isMulti={true}
						value={searchParams.locations}
						onChange={(options: any) =>{
							movePageToTop();
							setSearchParams({
								...searchParams,
								locations: options,
								pageNumber: 1,
							})
						}
						}
						isClearable
						styles={{
							control: (baseStyles, state) => ({
								...baseStyles,
								boxShadow: "none",
								borderColor: state.isFocused
									? "rgb(39, 129, 186)"
									: "gray",
								"&:hover": { borderColor: "rgb(39, 129, 186)" },
							}),
							...customSelectStyles,
							indicatorSeparator: () => ({
								display: "none",
							}),
							option: (provided, state) => ({
								...provided,
								backgroundColor: state.isFocused
									? "rgb(31, 103, 149)"
									: "white",
								color: state.isFocused ? "white" : "",
								minHeight: 36,
								fontSize: 13.5,
								cursor: "pointer",
								":hover": {
									backgroundColor: "rgb(31, 103, 149)",
									color: "white",
								},
							}),
							placeholder: (base) => ({
                                ...base,
                                color: 'rgb(99, 115, 129)'
                            }),
                            singleValue: (base) => ({
                                ...base,
                                color: 'rgb(0, 0, 0)',
                            }),
						}}
						components={{
							DropdownIndicator: DropdownIndicatorLocation,
						}}
						filterOption={(option, inputValue) => {
							return option.label
								?.toLowerCase()
								.includes(inputValue?.toLowerCase());
						}}
					/>
				</InputContainer>
				<InputContainer>
					<InputLabel>Last Updated Date</InputLabel>
					<StyledDatePicker
						isClearable
						selected={searchParams.lastUpdate}
						placeholderText="Select last updated date"
						onChange={(date: any) =>
							{
								movePageToTop();
								setSearchParams({
									...searchParams,
									lastUpdate: date,
									pageNumber: 1,
								})
							}
						}
						onKeyDown={handleNumericDateInput}
					/>
				</InputContainer>
				<InputContainer>
					<InputLabel>Offering Type</InputLabel>
					<AGSelect
						className="custom-select"
						options={offeringType?.map((item: any) => ({
							value: item?.offeringTypeId,
							label: item?.offeringTypeName,
						}))}
						placeholder="Select offering type"
						isMulti={true}
						value={searchParams.offeringTypes}
						onChange={(options: any) =>{
							movePageToTop();
							setSearchParams({
								...searchParams,
								offeringTypes: options,
								pageNumber: 1,
							})
						}}
						isClearable
						styles={{
							control: (baseStyles, state) => ({
								...baseStyles,
								boxShadow: "none",
								borderColor: state.isFocused
									? "rgb(39, 129, 186)"
									: "gray",
								"&:hover": { borderColor: "rgb(39, 129, 186)" },
							}),
							...customSelectStyles,
							indicatorSeparator: () => ({
								display: "none",
							}),
							option: (provided, state) => ({
								...provided,
								backgroundColor: state.isFocused
									? "rgb(31, 103, 149)"
									: "white",
								color: state.isFocused ? "white" : "",
								minHeight: 36,
								fontSize: 13.5,
								cursor: "pointer",
								":hover": {
									backgroundColor: "rgb(31, 103, 149)",
									color: "white",
								},
							}),
							placeholder: (base) => ({
                                ...base,
                                color: 'rgb(99, 115, 129)'
                            }),
                            singleValue: (base) => ({
                                ...base,
                                color: 'rgb(0, 0, 0)',
                            }),
						}}
						components={{
							DropdownIndicator: DropdownIndicatorOfferingType,
						}}
						filterOption={(option, inputValue) => {
							return option.label
								?.toLowerCase()
								.includes(inputValue?.toLowerCase());
						}}
					/>
				</InputContainer>
				<ButtonContainer>
					<AGButtonPrimarySearch
						disabled={
							searchParams.firmName === "" &&
							searchParams.locations.length === 0 &&
							searchParams.offeringTypes.length === 0 &&
							!searchParams.lastUpdate
						}
						onClick={() =>
							setSearchParams({
								...searchParams,
								firmName: "",
								locations: [],
								lastUpdate: undefined,
								offeringTypes: [],
								pageNumber: 1,
							})
						}>
						Clear search
					</AGButtonPrimarySearch>
				</ButtonContainer>
			</SearchContainer>

			<Result>Search results: ({servicesPagination?.maxLength}) </Result>
			<div className=" flex items-center  rounded-lg bg-white">
				<div
					onClick={() =>{
						movePageToTop();
						setSearchParams({
							...searchParams,
							sort: sortParam.order === 1 || sortParam.field !== SORT_FIELDS_OFFERING_ADMIN.OFFERING_TYPE_ID ? 1 : 0,
							sortField : SORT_FIELDS_OFFERING_ADMIN.OFFERING_TYPE_ID,
							pageNumber : 1,
						});
						if (sortParam.field !== SORT_FIELDS_OFFERING_ADMIN.OFFERING_TYPE_ID){
							setIsFirstSorting(true);
							setSortParam({
								...sortParam,
								order: 0,
								field: SORT_FIELDS_OFFERING_ADMIN.OFFERING_TYPE_ID,
							});
						}else{
							setSortParam({
								...sortParam,
								order: sortParam.order === 1 ? 0 : 1,
								field: SORT_FIELDS_OFFERING_ADMIN.OFFERING_TYPE_ID,
							});
						}
					}
					}
					className="h-10 flex-[1.8] text-[14px] border border-light-gray-500 py-2 px-2  font-bold">
					<div className="flex items-center">
						Offering Type &nbsp;{" "}
						{sortParam.field === SORT_FIELDS_OFFERING_ADMIN.OFFERING_TYPE_ID &&
							sortParam.order === 0 && (
								<ArrowUpIcon/>
							)}
						{sortParam.field === SORT_FIELDS_OFFERING_ADMIN.OFFERING_TYPE_ID &&
							sortParam.order === 1 && (
								<ArrowDownIcon/>
							)}
						{sortParam.field !== SORT_FIELDS_OFFERING_ADMIN.OFFERING_TYPE_ID && (
							<ArrowDownGrayIcon/>
						)}
					</div>
				</div>
				<div
					className="h-10 flex-[5.5] text-[14px] text-submit border-solid border border-light-gray-500 py-2 px-2  font-bold"
					onClick={() =>
					{
						movePageToTop();
						setSearchParams({
							...searchParams,
							sort: sortParam.order === 1 || sortParam.field !== SORT_FIELDS_OFFERING_ADMIN.SERVICE_NAME ? 1 : 0,
							sortField : SORT_FIELDS_OFFERING_ADMIN.SERVICE_NAME,
							pageNumber : 1,
						});
						if (sortParam.field !== SORT_FIELDS_OFFERING_ADMIN.SERVICE_NAME){
							setIsFirstSorting(true);
							setSortParam({
								...sortParam,
								order: 0,
								field: SORT_FIELDS_OFFERING_ADMIN.SERVICE_NAME,
							});
						}else{
							setSortParam({
								...sortParam,
								order: sortParam.order === 1 ? 0 : 1,
								field: SORT_FIELDS_OFFERING_ADMIN.SERVICE_NAME,
							});
						}
					}
					}>
					{" "}
					<div className="flex items-center">
						Offering Name &nbsp;{" "}
						{sortParam.field === SORT_FIELDS_OFFERING_ADMIN.SERVICE_NAME &&
							sortParam.order === 0 && (
								<ArrowUpIcon/>
							)}
						{sortParam.field === SORT_FIELDS_OFFERING_ADMIN.SERVICE_NAME &&
							sortParam.order === 1 && (
								<ArrowDownIcon/>
							)}
						{sortParam.field !== SORT_FIELDS_OFFERING_ADMIN.SERVICE_NAME && (
							<ArrowDownGrayIcon/>
						)}
					</div>
				</div>
				<FirmName
					onClick={() =>{
						movePageToTop();
						setSearchParams({
							...searchParams,
							sort: sortParam.order === 1 || sortParam.field !== SORT_FIELDS_OFFERING_ADMIN.FIRM_NAME ? 1 : 0,
							sortField : SORT_FIELDS_OFFERING_ADMIN.FIRM_NAME,
							pageNumber : 1,
						});
						if (sortParam.field !== SORT_FIELDS_OFFERING_ADMIN.FIRM_NAME){
							setIsFirstSorting(true);
							setSortParam({
								...sortParam,
								order: 0,
								field: SORT_FIELDS_OFFERING_ADMIN.FIRM_NAME,
							});
						}else{
							setSortParam({
								...sortParam,
								order: sortParam.order === 1 ? 0 : 1,
								field: SORT_FIELDS_OFFERING_ADMIN.FIRM_NAME,
							});
						}
					}
					}
					className="h-10 flex-[4] text-[14px] border border-light-gray-500 py-2 px-2  font-bold">
					<div className="flex items-center">
						Organization Name &nbsp;{" "}
						{sortParam.field === SORT_FIELDS_OFFERING_ADMIN.FIRM_NAME &&
							sortParam.order === 0 && (
								<ArrowUpIcon/>
							)}
						{sortParam.field === SORT_FIELDS_OFFERING_ADMIN.FIRM_NAME &&
							sortParam.order === 1 && (
								<ArrowDownIcon/>
							)}
						{sortParam.field !== SORT_FIELDS_OFFERING_ADMIN.FIRM_NAME && (
							<ArrowDownGrayIcon/>
						)}
					</div>
				</FirmName>
				<div
					onClick={() =>{
						movePageToTop();
						setSearchParams({
							...searchParams,
							sort: sortParam.order === 1 || sortParam.field !== SORT_FIELDS_OFFERING_ADMIN.REGION ? 1 : 0,
							sortField : SORT_FIELDS_OFFERING_ADMIN.REGION,
							pageNumber : 1,
						});
						if (sortParam.field !== SORT_FIELDS_OFFERING_ADMIN.REGION){
							setIsFirstSorting(true);
							setSortParam({
								...sortParam,
								order: 0,
								field: SORT_FIELDS_OFFERING_ADMIN.REGION,
							});
						}else{
							setSortParam({
								...sortParam,
								order: sortParam.order === 1 ? 0 : 1,
								field: SORT_FIELDS_OFFERING_ADMIN.REGION,
							});
						}
					}
					}
					className="h-10 flex-[2] text-[14px] border border-light-gray-500 py-2 px-2  font-bold">
					<div className="flex items-center">
						Region &nbsp;{" "}
						{sortParam.field === SORT_FIELDS_OFFERING_ADMIN.REGION &&
							sortParam.order === 0 && (
								<ArrowUpIcon/>
							)}
						{sortParam.field === SORT_FIELDS_OFFERING_ADMIN.REGION &&
							sortParam.order === 1 && (
								<ArrowDownIcon/>
							)}
						{sortParam.field !== SORT_FIELDS_OFFERING_ADMIN.REGION && (
							<ArrowDownGrayIcon/>
						)}
					</div>
				</div>
				<div
					onClick={() =>{
						movePageToTop();
						setSearchParams({
							...searchParams,
							sort: sortParam.order === 1 || sortParam.field !== SORT_FIELDS_OFFERING_ADMIN.CREATED_DATE ? 1 : 0,
							sortField : SORT_FIELDS_OFFERING_ADMIN.CREATED_DATE,
							pageNumber : 1,
						});
						if (sortParam.field !== SORT_FIELDS_OFFERING_ADMIN.CREATED_DATE){
							setIsFirstSorting(true);
							setSortParam({
								...sortParam,
								order: 0,
								field: SORT_FIELDS_OFFERING_ADMIN.CREATED_DATE,
							});
						}else{
							setSortParam({
								...sortParam,
								order: sortParam.order === 1 ? 0 : 1,
								field: SORT_FIELDS_OFFERING_ADMIN.CREATED_DATE,
							});
						}
					}
					}
					className="h-10 flex-[2] text-[14px] border border-light-gray-500 py-2 px-2  font-bold">
					<div className="flex items-center">
						Created Date &nbsp;{" "}
						{sortParam.field === SORT_FIELDS_OFFERING_ADMIN.CREATED_DATE &&
							sortParam.order === 0 && (
								<ArrowUpIcon/>
							)}
						{sortParam.field === SORT_FIELDS_OFFERING_ADMIN.CREATED_DATE &&
							sortParam.order === 1 && (
								<ArrowDownIcon/>
							)}
						{sortParam.field !== SORT_FIELDS_OFFERING_ADMIN.CREATED_DATE && (
							<ArrowDownGrayIcon/>
						)}
					</div>
				</div>
				<LastUpdate
					onClick={() =>{
						movePageToTop();
						setSearchParams({
							...searchParams,
							sort: sortParam.order === 1 || sortParam.field !== SORT_FIELDS_OFFERING_ADMIN.LAST_UPDATE ? 1 : 0,
							sortField : SORT_FIELDS_OFFERING_ADMIN.LAST_UPDATE,
							pageNumber : 1,
						});
						if (sortParam.field !== SORT_FIELDS_OFFERING_ADMIN.LAST_UPDATE){
							setIsFirstSorting(true);
							setSortParam({
								...sortParam,
								order: 0,
								field: SORT_FIELDS_OFFERING_ADMIN.LAST_UPDATE,
							});
						}else{
							setSortParam({
								...sortParam,
								order: sortParam.order === 1 ? 0 : 1,
								field: SORT_FIELDS_OFFERING_ADMIN.LAST_UPDATE,
							});
						}
					}
					}
					className="h-10 flex-[2.3] text-[14px] border border-light-gray-500 py-2 px-2  font-bold ">
					<div className="flex items-center">
						Last Updated Date &nbsp;{" "}
						{sortParam.field === SORT_FIELDS_OFFERING_ADMIN.LAST_UPDATE &&
							sortParam.order === 0 && (
								<ArrowUpIcon/>
							)}
						{sortParam.field === SORT_FIELDS_OFFERING_ADMIN.LAST_UPDATE &&
							sortParam.order === 1 && (
								<ArrowDownIcon/>
							)}
						{sortParam.field !== SORT_FIELDS_OFFERING_ADMIN.LAST_UPDATE && (
							<ArrowDownGrayIcon/>
						)}
					</div>
				</LastUpdate>
				<div className="h-10 flex-[2] text-[14px] border border-light-gray-500 py-2 px-2  font-bold">
					Offering's Action
				</div>
			</div>
			</StickyContainer>
			<CustomScroll style={{ minHeight: "72vh" }}>
			<PageInfiniteScroll
                items={filterServices ?? []}
                hasMore={filterServices ? filterServices.length < (servicesPagination?.maxLength as number) : false}
                loadMore={() => {
                    const currentPage = searchParams.pageNumber ?? 0
                    setSearchParams({ ...searchParams, pageNumber: currentPage + 1})
                }}
                renderItem={
                    (e: any, index, onClick, onSelect) => (
                        <div
							className=" flex items-center rounded-lg bg-white"
							key={e.conFirmDataId}>
							<Value className="h-10 flex-[1.8] text-[14px] border-solid border border-light-gray-500 py-2 px-2  ">
								{e?.firmData?.fkOfferingType?.offeringTypeName}
							</Value>
							<Value className="h-10 flex-[5.5] text-[14px] text-submit border-solid border border-light-gray-500 py-2 px-2 text-blue-700 flex">
								<Link
									className="underline line-clamp-1 max-w-[180px] block text-ellipsis overflow-hidden whitespace-nowrap"
									to={`/commerceProfile/${e.firmData.fkOrgId}?tab=${getOfferingTypeName(e.firmData.fkOfferingTypeId)}&serviceId=${e.conFirmDataId}`}
									target="_blank"
									title={e.mainService.mainServiceName}
									style={{
										maxWidth: e?.firmData?.isDraff || e?.firmData?.fkStatus?.statusName ? "180px" : "none"
									  }}
								>
									{e.mainService.mainServiceName}
								</Link>
								{e?.firmData?.isDraff ? 
								<span className="text-[#58585B]">&nbsp;(Draft)</span> : (
								e?.firmData?.fkStatus?.statusName ? 
								<span className="text-[#58585B]"> &nbsp;({e?.firmData?.fkStatus?.statusName})</span>
								: null)}
							</Value>
							<FirmNameValue className="h-10 flex-[4] text-[14px] border-solid border border-light-gray-500 py-2 px-2  ">
								<p className="line-clamp-1" title={e.firmName}>{e.firmName}</p>
							</FirmNameValue>
							<Value className="h-10 flex-[2] text-[14px] border-solid border border-light-gray-500 py-2 px-2  ">
								{e.netRegionName}
							</Value>
							<Value className="h-10 flex-[2] text-[14px] border-solid border border-light-gray-500 py-2 px-2  ">
								{moment(e.createdDate).format(
									"MM/DD/YYYY",
								)}
							</Value>
							<LastUpdateValue className="h-10 flex-[2.3] text-[14px] border-solid border border-light-gray-500 py-2 px-2  ">
								{moment(e.lastUpdate).format(
									"MM/DD/YYYY",
								)}
							</LastUpdateValue>
							<Value className=" h-10 flex-[2] text-[14px] border-solid border border-light-gray-500 py-2 px-2  ">
								<AGButtonPrimary
									onClick={() => {
										var offeringType = getOfferingTypeName(e.firmData.fkOfferingTypeId);
										if (offeringType === "service"){
											setServiceId(e.conFirmDataId);
										}
										if (offeringType === "product"){
											setProductId(e.conFirmDataId);
										}
										if (offeringType === "secondment"){
											setSecondmentId(e.conFirmDataId);
										}
										setSelectedService(
											e.conFirmDataId,
										);
										setSelectedOfferingType(offeringType);
										setSelectedFirm(e?.firmData?.fkOrgId);
									}}>
									Edit
								</AGButtonPrimary>
								<AGButton
									onClick={() => {
										var offeringType = getOfferingTypeName(e.firmData.fkOfferingTypeId);
										toggleOpenConfirm();
										setSelectedOfferingType(offeringType);
										setSelectedService(
											e.conFirmDataId,
										);
									}}>
									Delete
								</AGButton>
							</Value>
						</div>
                    )
                }
            />
			</CustomScroll>
		</Container>
	);
};

export default ExpertiseServiceManagement;
